"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Filter.css");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _isoWeek = _interopRequireDefault(require("dayjs/plugin/isoWeek"));
require("dayjs/locale/fr");
var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _AdapterDayjs = require("@mui/x-date-pickers/AdapterDayjs");
var _DatePicker = require("@mui/x-date-pickers/DatePicker");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : DateFilter.js
* Description : Ce fichier contient la définition du composant DateFilter 
*               Ce composant affiche un champ date avec un calendrier de sélection de la date
* Date de création : 27 juin 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ // <-- importe la locale
/* Hook */ // définit 'fr' comme locale globale
_dayjs["default"].locale('fr');
_dayjs["default"].extend(_isoWeek["default"]);

/**
* DateFilter : ce champ permet de sélectionner une date dans un calendrier
*
* Type : composant 
*
* Parametres : 
*  - option -- parametre pour choisir la selection de la date par jour, mois, semaine etc
*  - labelText -- texte affiché au dessus du champ pour apporter des précisions
*  - selectedDate -- date sélectionnée
*  - setSelectedDate -- fonction pour mettre à jour la variable selectedDate
*  - clearable -- option pour remettre le champ vide
*/
function DateFilter(_ref) {
  var option = _ref.option,
    labelText = _ref.labelText,
    selectedDate = _ref.selectedDate,
    setSelectedDate = _ref.setSelectedDate,
    clearable = _ref.clearable;
  // Define useState hooks
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    cleared = _useState2[0],
    setCleared = _useState2[1];
  var _useState3 = (0, _react.useState)(["year", "month", "day"]),
    _useState4 = _slicedToArray(_useState3, 2),
    view = _useState4[0],
    setView = _useState4[1];
  var _useState5 = (0, _react.useState)("day"),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];

  // Define functions
  var handleDate = function handleDate(newValue) {
    setSelectedDate(newValue);
  };

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (option === 'month') {
      setView(["year", "month"]);
      setOpen("month");
    } else if (option === 'year') {
      setView(["year"]);
      setOpen("year");
    } else {
      setView(["year", "month", "day"]);
      setOpen("day");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option]);
  (0, _react.useEffect)(function () {
    if (cleared === true) {
      setSelectedDate(null);
      setCleared(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cleared]);

  // Render component
  // L'utilisation de disableFuture dans DatePicker bloque automatiquement toute date après aujourd'hui
  if (labelText !== 'none') {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: "list-filter-label",
        children: [labelText, " :"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalizationProvider.LocalizationProvider, {
        dateAdapter: _AdapterDayjs.AdapterDayjs,
        adapterLocale: "fr",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePicker.DatePicker, {
          views: view,
          openTo: open,
          slotProps: {
            textField: {
              className: 'date-filter'
            },
            field: {
              clearable: clearable,
              onClear: function onClear() {
                return setCleared(true);
              }
            }
          },
          value: selectedDate,
          onChange: function onChange(newValue) {
            return handleDate(newValue);
          },
          format: option === 'week' ? function (val) {
            return "S".concat(selectedDate.isoWeek(), "-").concat(selectedDate.year());
          } : null,
          disableFuture: true
        })
      })]
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalizationProvider.LocalizationProvider, {
        dateAdapter: _AdapterDayjs.AdapterDayjs,
        adapterLocale: "fr",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePicker.DatePicker, {
          views: view,
          openTo: open,
          slotProps: {
            textField: {
              className: 'date-filter'
            },
            field: {
              clearable: clearable,
              onClear: function onClear() {
                return setCleared(true);
              }
            }
          },
          value: selectedDate,
          onChange: function onChange(newValue) {
            return handleDate(newValue);
          },
          format: option === 'week' ? "S".concat(selectedDate.isoWeek(), "-").concat(selectedDate.year()) : null,
          disableFuture: true
        })
      })
    });
  }
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
DateFilter.propTypes = {
  labelText: _propTypes["default"].string,
  setSelectedDate: _propTypes["default"].func
};
var _default = exports["default"] = DateFilter;